/**
 * @name barrel
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNSAyYTM0LjUgMzQuNSAwIDAwMCAyMCIgLz4KICA8cGF0aCBkPSJNMTMuNSAyYTM0LjUgMzQuNSAwIDAxMCAyMCIgLz4KICA8cGF0aCBkPSJNNC42NyAxN2gxNC42NyIgLz4KICA8cGF0aCBkPSJNNC42NyA3aDE0LjY3IiAvPgogIDxwYXRoIGQ9Ik02LjIzIDMuMDZhMTkgMTkgMCAwMDAgMTcuODhBMiAyIDAgMDA4IDIyaDhhMiAyIDAgMDAxLjc3LTEuMDYgMTkgMTkgMCAwMDAtMTcuODhBMiAyIDAgMDAxNiAySDhhMiAyIDAgMDAtMS43NyAxLjA2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/barrel
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Barrel: string = `
<svg
  class="lucide lucide-barrel"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10.5 2a34.5 34.5 0 000 20" />
  <path d="M13.5 2a34.5 34.5 0 010 20" />
  <path d="M4.67 17h14.67" />
  <path d="M4.67 7h14.67" />
  <path d="M6.23 3.06a19 19 0 000 17.88A2 2 0 008 22h8a2 2 0 001.77-1.06 19 19 0 000-17.88A2 2 0 0016 2H8a2 2 0 00-1.77 1.06" />
</svg>
`;

export default Barrel;
